import React from 'react';
import { Grid } from '@mui/material';
import { ReQuartzCron, Tab } from '@sbzen/re-cron';
import cronstrue from 'cronstrue';
import { styled } from '@mui/material/styles';

export interface CronExpressionPickerProps {
  value: string;
  onChange: (cron: string) => void;
  onHumanReadableChange?: (description: string) => void;
  disableDate?: boolean;
  hideTimeFields?: boolean; // Hide minutes and hours, show only days, months, and years
}

export const StyledCronContainer = styled('div')(({ theme }) => ({
  'c-quartz': {
    '--cron-font-family': theme.typography.fontFamily,
  },

  '.recron-input, .recron-select': {
    border: `1px solid ${theme.palette.custom.gray[400]} !important`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    fontSize: theme.typography.displaySM.fontSize,
  },

  '.recron-card': {
    boxShadow: theme.shadows[1],
    borderRadius: theme.shape.borderRadius * 2,
  },
  '.nav-tabs': {
    display: 'flex',
    marginBlockStart: 0,
    marginBlockEnd: 0,
    marginLeft: '12px',
    marginBottom: '-1px',
    listStyleType: 'none',
    paddingInlineStart: 0,
  },
  '.row': {
    display: 'flex',
    flexWrap: 'wrap',
  },
  '.form-inline': {
    display: 'flex',
  },
  '.form-inline .form-control': {
    margin: '0 6px',
  },
  '.form-group': {
    marginBottom: theme.spacing(4),
  },
  '.c-tab-content': {
    border: '1px solid',
    borderRadius: '12px',
    padding: theme.spacing(6),
    borderColor: theme.palette.custom.gray[300],
    marginTop: 0,
  },
  '.c-tab-item': {
    border: '1px solid',
    borderColor: theme.palette.custom.gray[300],
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    margiLeft: '0px',
  },
  '.c-tab-item :not(.active)': {
    backgroundColor: theme.palette.custom.gray[100],
    cursor: 'pointer',
  },
  '.nav-link': {
    border: 'none',
    background: 'none',
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    padding: theme.spacing(4),
  },
  '.c-and-list, .c-and-weekday-list, .c-and-monthday-list': {
    marginLeft: '14px',
    marginTop: '4px',
  },
  '[tab-name="MINUTES"] .c-and-item, [tab-name="HOURS"] .c-and-item, [tab-name="DAY"] .c-and-monthday-item': {
    width: '44px',
    margin: '0 4px',
  },
  '[tab-name="DAY"] .c-and-weekday-item, [tab-name="MONTH"] .c-and-item': {
    width: '112px',
    margin: '0 4px',
  },
  '[tab-name="YEAR"] .c-and-item': {
    width: '66px',
    margin: '0 4px',
  },
}));

const CronExpressionPicker: React.FC<CronExpressionPickerProps> = ({
  value,
  onChange,
  onHumanReadableChange,
  disableDate,
  hideTimeFields,
}) => {
  const handleCronChange = (e: string) => {
    onChange(e);
    if (onHumanReadableChange) {
      const human = cronstrue.toString(e);

      onHumanReadableChange(human);
    }
  };

  // Determine which tabs to show
  const tabs = hideTimeFields
    ? [Tab.DAY, Tab.MONTH, Tab.YEAR]
    : [Tab.MINUTES, Tab.HOURS, ...(disableDate ? [] : [Tab.DAY, Tab.MONTH, Tab.YEAR])];

  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
      >
        <StyledCronContainer>
          <ReQuartzCron
            value={value}
            onChange={handleCronChange}
            disabled={false}
            tabs={tabs}
          />
        </StyledCronContainer>
      </Grid>
    </Grid>
  );
};

export default CronExpressionPicker;
